var map = {
	"./AfroDance1.jpeg": 4535,
	"./AfroDance2.jpeg": 6842,
	"./AfroDance3.jpeg": 9889,
	"./AfroDance4.jpeg": 1252,
	"./WhatsApp Image 2026-03-17 at 1.11.59 PM.jpeg": 9000,
	"./WhatsApp Image 2026-03-17 at 1.12.00 PM.jpeg": 683,
	"./WhatsApp Image 2026-03-17 at 1.12.03 PM.jpeg": 5460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8299;